import { useMemo } from 'react';

import { twMerge } from 'tailwind-merge';

import { cs, useTheme } from '@/_shared';

import type { DivProps } from '../../types';

export const Card = ({ ref, ...props }: DivProps) => {
  const { className, children, ...other } = props;
  const { card } = useTheme();

  const cls = useMemo(() => twMerge(card.base, cs('rounded-[2.7rem]'), className), [card.base, className]);

  return (
    <div className={cls} ref={ref} {...other}>
      {children}
    </div>
  );
};
